// extracted by mini-css-extract-plugin
module.exports = {"body":"ButtonAddStable_body___Nzd2"};